import { Box, Button, Icon, IconButton, Text } from "@chakra-ui/react";
import { MdGamepad } from "react-icons/md";
import { useUserInterfaceStore } from "../../store";

export default function TransformTools() {
  const rotationAxes = useUserInterfaceStore((s) => s.rotationAxes);
  const setRotationAxes = useUserInterfaceStore((s) => s.setRotationAxes);
  const showDesktopMovePanel = useUserInterfaceStore((s) => s.showDesktopMovePanel);
  const setShowDesktopMovePanel = useUserInterfaceStore((s) => s.setShowDesktopMovePanel);

  return (
    <Box
      bg="#141414"
      borderRadius="0"
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap="8px"
      px={3}
      py={2}
    >
      <Text fontSize="9px" fontWeight="bold" textTransform="uppercase" letterSpacing="wide" color="gray.500" fontFamily="DM Mono" whiteSpace="nowrap">
        Rotate
      </Text>
      {["x", "y", "z"].map((axis) => (
        <Button
          key={axis}
          size="xs"
          variant={rotationAxes[axis] ? "solid" : "outline"}
          bg={rotationAxes[axis] ? "white" : "transparent"}
          color={rotationAxes[axis] ? "black" : "gray.400"}
          borderColor="gray.600"
          borderRadius="0"
          fontFamily="DM Mono"
          minW="26px"
          h="26px"
          p={0}
          onClick={() => setRotationAxes({ x: axis === "x", y: axis === "y", z: axis === "z" })}
        >
          {axis.toUpperCase()}
        </Button>
      ))}

      <Box w="1px" h="20px" bg="gray.700" mx={1} />

      <IconButton
        size="xs"
        aria-label="Toggle move panel"
        bg={showDesktopMovePanel ? "white" : "transparent"}
        color={showDesktopMovePanel ? "black" : "gray.400"}
        borderRadius="0"
        border="1px solid"
        borderColor="gray.600"
        w="26px"
        h="26px"
        minW={0}
        p={0}
        onClick={() => setShowDesktopMovePanel(!showDesktopMovePanel)}
        title="Toggle button controls"
      >
        <Icon>
          <MdGamepad />
        </Icon>
      </IconButton>
    </Box>
  );
}
